<div *ngIf="isLoading" class="loading">
  <div class="uil-ring-css" style="transform: scale(0.79)">
    <div></div>
  </div>
</div>

<div class="container" fxLayoutGap="10px" fxLayout="column">
  <mat-card fxFlexLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
    <mat-form-field appearance="outline">
      <mat-label>Du</mat-label>
      <input
        matInput
        [matDatepicker]="date_Debut"
        placeholder="Du"
        [(ngModel)]="dateDeb"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="date_Debut"
      ></mat-datepicker-toggle>
      <mat-datepicker #date_Debut></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Au</mat-label>
      <input
        matInput
        [matDatepicker]="date_Fin"
        placeholder="Au"
        [(ngModel)]="dateFin"
      />
      <mat-datepicker-toggle matSuffix [for]="date_Fin"></mat-datepicker-toggle>
      <mat-datepicker #date_Fin></mat-datepicker>
    </mat-form-field>

    <button
      [disabled]="!dateDeb || !dateFin"
      fxFlex="10"
      mat-raised-button
      color="primary"
      (click)="refreshData()"
    >
      Rechercher
    </button>
    <!-- <button
      [disabled]="!dataLoaded"
      fxFlex="10"
      mat-raised-button
      color="success"
      (click)="
        exporter.exportTable('Excel', {
          fileName: 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin
        })
      "
    >
      Exporter Excel
    </button> -->
    <!-- <button
      [disabled]="!dataLoaded"
      mat-raised-button
      color="success"
      (click)="
        exporter.exportTable('csv', {
          fileName: 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin
        })
      "
    >
      Exporter CSV
    </button> -->
  </mat-card>

  <!-- <app-table matTableExporter  #tableSummary [source]="summaryTSource" #exporter="matTableExporter" ></app-table> -->

  <table
    matTableExporter
    class="w-full mat-elevation-z8"
    #tableSummary
    mat-table
    [dataSource]="SummarySource"
    #exporter="matTableExporter"
  >
    <ng-container matColumnDef="Date">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Date
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.debut | date: "dd/MM/yyyy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="OF_Num">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        OF_Num
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.OF_Num }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Perso_Matricule">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Matricule
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.Perso_Matricule }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nom">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Nom
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.nom }}
      </td>
    </ng-container>

    <ng-container matColumnDef="prenom">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Prenom
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.prenom }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Machine_Code">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Machine
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.Machine_Code }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Realise">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Réalisé
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.Realise }}
      </td>
    </ng-container>

    <ng-container matColumnDef="objectif">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Objectif
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.objectif }}
      </td>
    </ng-container>

    <ng-container matColumnDef="gain">
      <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef>
        Gain
      </th>
      <td class="font-size-12" mat-cell *matCellDef="let element">
        {{ element.gain }}
      </td>
    </ng-container>

    <tr
      class="bg-color h-50"
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
